"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var tools_1 = require("../utils/tools");
var NAME = 'italic';
var toggleMarkItalic = function (editor) {
    var format = editor.getFormat();
    var status = !Boolean(format.italic);
    editor.setFormat({ italic: status });
    return true;
};
var Italic = /** @class */ (function (_super) {
    __extends(Italic, _super);
    function Italic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'em'; };
        _this.textMatcher = [
            {
                matcher: /\*([^*]+)\*\s$/
            }
        ];
        _this.parseDOM = [{ tag: 'em', priority: 25 }, { tag: 'i', priority: 25 }, { style: 'font-style=italic' }];
        return _this;
    }
    Italic.keymap = {
        'Mod-i': toggleMarkItalic,
        'Mod-I': toggleMarkItalic
    };
    return Italic;
}(core_utilities_1.Inline));
exports.Italic = Italic;
var ItalicController = /** @class */ (function (_super) {
    __extends(ItalicController, _super);
    function ItalicController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'italic',
            tooltip: 'italic'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return ItalicController;
}(core_utilities_1.SylController));
exports.ItalicController = ItalicController;
var ItalicPlugin = /** @class */ (function (_super) {
    __extends(ItalicPlugin, _super);
    function ItalicPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = ItalicController;
        _this.Schema = Italic;
        return _this;
    }
    return ItalicPlugin;
}(core_utilities_1.SylPlugin));
exports.ItalicPlugin = ItalicPlugin;
//# sourceMappingURL=italic.js.map